export type PricesCurrency = 'USD' | 'GEL' | 'RUB';

// Shared between PriceTable and QuoteCalculator on /prices, so toggling
// in one updates the other instantly. Initialised lazily; default USD.
export function usePricesCurrency() {
  return useState<PricesCurrency>('prices-currency', () => 'USD');
}
